import { render, staticRenderFns } from "./IconSvgBuy.vue?vue&type=template&id=cba181b8&scoped=true&"
import script from "./IconSvgBuy.vue?vue&type=script&lang=js&"
export * from "./IconSvgBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba181b8",
  null
  
)

export default component.exports